/* eslint-disable global-require */
import Button from "@material-ui/core/Button";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { instance } from "Actions/AxiosInstance";
import tick from "Assets/newicons/config-dashboard/notify-check-tick.svg";
import newTabIcon from "Assets/newicons/web-technology/new-tab-external-link/outline/new-tab-external-link-outline-16px.svg";
import flashIcon from "Assets/Svg/camera-flash.svg";
import configDashboad from "Assets/Svg/config-dashboad.svg";
import LabelIcon from "Component/Labels/LabelIcon";
import headersList from "Constants/headersList";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { CONFIG_DATA } from "./data";
import "./index.css";

const styles = () => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
  typography: {
    color: "#fff",
  },

  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    color: "#fff",
    fontSize: 18,
    paddingTop: 4,
    fontWeight: "bold",
  },
  textdeco: {
    textDecoration: "none",
  },
  cardContent: {
    padding: "2px 16px 0px 16px !important",
  },
});

class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectemodule: 3,

      actionidList: "",
      companyName: "",
      companystructure: {},
      isbucompleted: false,
      isdeptcompleted: false,
      isdescompleted: false,
      isteamcompleted: false,
      isworkflowcompleted: false,
      iscustomdatacompleted: false,
      isexitpolicycompleted: false,
      isbrandingcompleted: false,
      isemailcompleted: false,
      isofficecompleted: false,
      isdetailscompleted: false,

      employeeconfig: {},
      leaveconfig: {},
      attendanceconfig: {},
      expanded: false,
      configdata: CONFIG_DATA,
      superpower: false,
      showtext: false,
      tickIcon: tick,
      progress: "",
    };
    this.getConfigList = this.getConfigList.bind(this);
    this.showsuperpower = this.showsuperpower.bind(this);
    this.verifySetup = this.verifySetup.bind(this);
  }

  componentDidMount() {
    // this.calculateSetupProgress();
  }

  componentWillMount() {
    this.setState({ companyName: this.props.companyName });
    this.getConfigList();
  }

  getConfigList() {
    let companystructure;
    let employeeconfig;
    let leaveconfig;
    let attendanceconfig;

    instance.get("/subscription/checkconfigsetup").then((result) => {
      result.data.result &&
      result.data.result.forEach((item) => {
        companystructure = item.configsetup.companystructure;

        employeeconfig = item.configsetup.employeeconfig;

        leaveconfig = item.configsetup.leaveconfig;

        attendanceconfig = item.configsetup.attendanceconfig;
      });
      this.setState(
        {
          companystructure,
          employeeconfig,
          leaveconfig,
          attendanceconfig,
          isbucompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.companystructure &&
            result.data.result[0].configsetup.companystructure.businessunit,
          isdeptcompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.companystructure &&
            result.data.result[0].configsetup.companystructure.department,
          isdescompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.companystructure &&
            result.data.result[0].configsetup.companystructure.designation,
          isteamcompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.companystructure &&
            result.data.result[0].configsetup.companystructure.team,
          isworkflowcompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.employeeconfig &&
            result.data.result[0].configsetup.employeeconfig.approvalworkflow,
          isexitpolicycompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.employeeconfig &&
            result.data.result[0].configsetup.employeeconfig.isexitpolicy,
          iscustomdatacompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.employeeconfig &&
            result.data.result[0].configsetup.employeeconfig.iscustomdata,
          isprobationcompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.employeeconfig &&
            result.data.result[0].configsetup.employeeconfig.probation,

          isbrandingcompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.accountconfig &&
            result.data.result[0].configsetup.accountconfig.interfacebranding,
          isemailcompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.accountconfig &&
            result.data.result[0].configsetup.accountconfig.emailbranding,
          isofficecompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.accountconfig &&
            result.data.result[0].configsetup.accountconfig.companyofficess,
          isdetailscompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.accountconfig &&
            result.data.result[0].configsetup.accountconfig.incorporationdetail,
        },
        () => this.editIcon(),
      );
    });
  }

  verifySetup(id) {
    const { configdata } = this.state;
    let companystructure;
    let employeeconfig;
    let leaveconfig;
    let attendanceconfig;

    instance.get(`/subscription/checkconfigsetup/${id}`).then((result) => {
      console.log(result);
      result.data.result &&
      result.data.result.forEach((item) => {
        companystructure = item.configsetup.companystructure;

        employeeconfig = item.configsetup.employeeconfig;

        leaveconfig = item.configsetup.leaveconfig;

        attendanceconfig = item.configsetup.attendanceconfig;
      });
      this.setState(
        {
          companystructure,
          employeeconfig,
          leaveconfig,
          attendanceconfig,
          isbucompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.companystructure &&
            result.data.result[0].configsetup.companystructure.businessunit,
          isdeptcompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.companystructure &&
            result.data.result[0].configsetup.companystructure.department,
          isdescompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.companystructure &&
            result.data.result[0].configsetup.companystructure.designation,
          isteamcompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.companystructure &&
            result.data.result[0].configsetup.companystructure.team,
          isworkflowcompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.employeeconfig &&
            result.data.result[0].configsetup.employeeconfig.approvalworkflow,
          isexitpolicycompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.employeeconfig &&
            result.data.result[0].configsetup.employeeconfig.isexitpolicy,
          iscustomdatacompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.employeeconfig &&
            result.data.result[0].configsetup.employeeconfig.iscustomdata,
          isprobationcompleted:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].configsetup &&
            result.data.result[0].configsetup.employeeconfig &&
            result.data.result[0].configsetup.employeeconfig.probation,
          configdata,
        },
        () => this.editIcon(),
      );
    });
    // window.location.reload();
  }

  editIcon = () => {
    const { configdata } = this.state;
    configdata[0].subsection[0].icon =
      this.state.isbucompleted == true
        ? this.state.tickIcon
        : configdata[0].subsection[0].icon;
    configdata[0].subsection[1].icon =
      this.state.isdeptcompleted == true
        ? this.state.tickIcon
        : configdata[0].subsection[1].icon;
    configdata[0].subsection[2].icon =
      this.state.isdescompleted == true
        ? this.state.tickIcon
        : configdata[0].subsection[2].icon;
    configdata[0].subsection[3].icon =
      this.state.isteamcompleted == true
        ? this.state.tickIcon
        : configdata[0].subsection[3].icon;
    configdata[1].subsection[0].icon =
      this.state.isworkflowcompleted == true
        ? this.state.tickIcon
        : configdata[1].subsection[0].icon;

    configdata[1].subsection[1].icon =
      this.state.isprobationcompleted == true
        ? this.state.tickIcon
        : configdata[1].subsection[1].icon;
    configdata[1].subsection[2].icon =
      this.state.isexitpolicycompleted == true
        ? this.state.tickIcon
        : configdata[1].subsection[2].icon;
    configdata[1].subsection[3].icon =
      this.state.iscustomdatacompleted == true
        ? this.state.tickIcon
        : configdata[1].subsection[3].icon;
    configdata[2].subsection[0].icon =
      this.state.isbrandingcompleted == true
        ? this.state.tickIcon
        : configdata[2].subsection[0].icon;
    configdata[2].subsection[1].icon =
      this.state.isemailcompleted == true
        ? this.state.tickIcon
        : configdata[2].subsection[1].icon;
    configdata[2].subsection[2].icon =
      this.state.isofficecompleted == true
        ? this.state.tickIcon
        : configdata[2].subsection[2].icon;
    configdata[2].subsection[3].icon =
      this.state.isdetailscompleted == true
        ? this.state.tickIcon
        : configdata[2].subsection[3].icon;

    this.setState({ configdata });
  };

  showsuperpower(sectionid) {
    const { configdata } = this.state;

    configdata && configdata[sectionid] &&
      configdata[sectionid].subsection.map((item) => {
        if (item.superpowerid == 1) {
          item.superpower = !item.superpower;
          item.showtext = !item.showtext;
        }
      });

    if (sectionid == 2) {
      const showtext = configdata && configdata[1] && !configdata[1].showtext;
      if(configdata && configdata[1]) configdata[1].showtext = showtext;
      configdata && configdata[1] && configdata[1].subsection.map((item) => {
        if (item.superpowerid == 1) {
          item.superpower = !item.superpower;
          item.showtext = !item.showtext;
        }
      });
    } else {
      const showtext = configdata && configdata[0] && !configdata[0].showtext;
      if(configdata && configdata[0]) configdata[0].showtext = showtext;
    }

    this.setState({ configdata });
  }

  handleExpandClick = (event, isExpanded, panel) => {
    isExpanded
      ? this.setState({ expanded: panel })
      : this.setState({ expanded: false });
  };

  render() {
    const { classes } = this.props;
    const {
      isbucompleted,
      isdeptcompleted,
      iscustomdatacompleted,
      isdescompleted,
      isexitpolicycompleted,
      isprobationcompleted,
      isteamcompleted,
      isworkflowcompleted,
    } = this.state;
    const progress =
      (isbucompleted +
        isdeptcompleted +
        iscustomdatacompleted +
        isdescompleted +
        isexitpolicycompleted +
        isprobationcompleted +
        isteamcompleted +
        isworkflowcompleted) /
      8;

    const totalProgress = progress * 100;
    const itemleft =
      8 -
      (isbucompleted +
        isdeptcompleted +
        iscustomdatacompleted +
        isdescompleted +
        isexitpolicycompleted +
        isprobationcompleted +
        isteamcompleted +
        isworkflowcompleted);
    return (
      <main className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.Config.Dashboard.header}</title>
        </Helmet>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Paper className="rounded-rectangle-paper text-center width70 padding24 margin-bottom-24">
            <p className="large-text-dark-secondary t-bold margin-bottom-16">
              Finish setting up your account
            </p>
            <p className="large-text-dark-secondary">
              Welcome to the config mode of sumHR. Use this dashboard to
              transform sumHR to suit your desired needs. Let’s get started!
            </p>
            {/* <Button
              variant="contained"
              className="btn btn-primary-md-blue margin-top-32"
              color="primary"
              onClick={this.onCreate}
            >
              Let’s go!
            </Button> */}
          </Paper>
          {/* <img src={configDashboad} style={{ marginTop: -10 }}></img> */}
        </div>
        <div
          className="display-flex margin-bottom-8"
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <span className="normal-blue t-bold" style={{ fontSize: 24 }}>
            {totalProgress}% complete
          </span>
          <span className="small-dark-secondary">{itemleft} items left</span>
        </div>

        <LinearProgress
          variant="determinate"
          value="50"
          style={{ height: 12, borderRadius: 12 }}
        />

        <div className="margin-top-40">
          {this.state.configdata.map((item) => (
            <div className="margin-bottom-40">
              <div
                className="display-flex margin-bottom-8"
                style={{ justifyContent: "space-between" }}
              >
                <LabelIcon
                  label={item.sectiontitle}
                  img={item.sectionicon}
                  labelClassNames="normal-dark margin-left-8"
                  iconHeight="24"
                />
                {item.issuperpowers && (
                  <div
                    onClick={() => {
                      this.setState({
                        showtext: !item.showtext,
                      });
                      this.showsuperpower(item.sectionid);
                    }}
                    className="cursor-pointer"
                  >
                    <LabelIcon
                      label={
                        item.showtext
                          ? "Show superpower tasks"
                          : "Hide superpower tasks"
                      }
                      img={flashIcon}
                      labelClassNames="normal-blue t-bold margin-left-8"
                      iconHeight="24"
                    />
                  </div>
                )}
              </div>
              {item.subsection.map((x) => (
                <ExpansionPanel
                  className="padding0"
                  style={
                    x.superpower == true
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  defaultExpanded={false}
                  expanded={this.state.expanded === x.subsectiontitle}
                  onChange={(e, isexpanded) =>
                    this.handleExpandClick(e, isexpanded, x.subsectiontitle)
                  }
                >
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <div>
                      <span
                        style={{
                          width: 16,
                          height: 16,
                          margin: "0 16px 0 0",
                          padding: 16,
                          background: "#edf7f6",
                          borderRadius: 30,
                          display: "inline-block",
                        }}
                      >
                        <img src={x.icon} height="16"></img>
                      </span>
                      <span className="normal-dark-secondary t-bold">
                        {x.subsectiontitle}
                      </span>
                      <span className="black-dot"></span>
                      <span className="extra-small-dark-secondary">
                        About {x.duration}
                      </span>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Grid container>
                      <Grid item sm={12} md={6}>
                        <p className="normal-dark margin-bottom-24">
                          {x.description}
                        </p>
                        <p className="small-dark-secondary t-bold">Steps</p>
                        <ol className="margin-top-8 padding-left-16">
                          {x.steps.map((step) => (
                            <li className="margin-bottom-16">
                              <div className="display-flex">
                                <span className="small-dark-secondary">
                                  {step.text}
                                </span>
                                {step.url && (
                                  <a href={step.url} target="_blank">
                                    <img
                                      src={newTabIcon}
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: 8,
                                      }}
                                    ></img>
                                  </a>
                                )}
                              </div>
                              {step.note && (
                                <p
                                  className="extra-small-dark-secondary"
                                  style={{
                                    background: "#dcf2f1",
                                    display: "inline-block",
                                  }}
                                >
                                  {step.note}
                                </p>
                              )}
                            </li>
                          ))}
                        </ol>

                        {x.icon != this.state.tickIcon && (
                          <Button
                            variant="contained"
                            className="btn btn-secondary-md-blue margin-bottom-16"
                            color="primary"
                            onClick={() => this.verifySetup(item.sectionid + 1)}
                            // onClick={this.verifySetup}
                          >
                            Verify setup
                          </Button>
                        )}
                      </Grid>
                      <Grid
                        item
                        sm={12}
                        md={6}
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <img src={x.image} height="320" width="320"></img>
                      </Grid>
                    </Grid>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ))}
            </div>
          ))}
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  REQUESTCENTER: state.REQUESTCENTER,
  all: state,
  companyName: state.SubscriptionInfo.SubscriptionData.subscriptionname,
  selectionReducer: state.selectionReducer,
});

export default connect(
  mapStateToProps,
  null,
)(withStyles(styles, { withTheme: true })(LandingPage));
